// extracted by mini-css-extract-plugin
export const disclaimer = "CruiseCardSummary-module--disclaimer--1D0eH";
export const suiteName = "CruiseCardSummary-module--suite-name--2bQZA";